import React from "react";
import { ArrowUpRight } from "lucide-react";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/7e80ae73-7e48-43aa-9692-c3f9d2da880e/images/c1861adecee58edf3815a329e90c42f24a93c1662f4b14ab27785448bbad8eb9.png";
const BOOKING_URL = "https://alchemy-practice.clientsecure.me/";

export default function Hero() {
    return (
        <section id="top" data-testid="hero-section" className="relative min-h-[100vh] flex items-end overflow-hidden" style={{ background: "linear-gradient(90deg, #FAFAF8 0%, #FAFAF8 45%, #EEF2ED 55%, #EEF2ED 100%)" }}>
            {/* Image panel — overflow-hidden so ken-burns scaling never bleeds outside */}
            <div className="absolute inset-y-0 right-0 w-full lg:w-[60%] overflow-hidden">
                <div className="absolute inset-0 animate-ken-burns">
                    <img
                        src={HERO_IMG}
                        alt="Soft morning light through an English country window"
                        className="h-full w-full object-cover"
                        style={{ filter: "brightness(1.12) saturate(0.92)" }}
                    />
                </div>
            </div>
            {/* Static overlays — cover the ENTIRE section, no animation, no transition, no transform */}
            <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(90deg, #FAFAF8 0%, rgba(250,250,248,0.75) 25%, rgba(238,242,237,0.45) 60%, rgba(238,242,237,0.55) 100%)", transform: "none", animation: "none", transition: "none" }} />
            <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg, transparent 0%, rgba(238,242,237,0.3) 100%)", transform: "none", animation: "none", transition: "none" }} />

            <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-12 pt-32 pb-20 lg:pb-28">
                <div className="max-w-3xl">
                    <h1
                        data-testid="hero-headline"
                        className="font-serif text-5xl sm:text-7xl lg:text-[88px] leading-[0.95] text-charcoal text-balance"
                    >
                        Where Therapy
                        <br />
                        Becomes <em className="text-gold not-italic font-medium" style={{ fontStyle: "italic", fontFamily: "'Cormorant Garamond', serif" }}><span className="italic">Alchemy</span></em>
                    </h1>

                    <p
                        data-testid="hero-tagline"
                        className="mt-8 max-w-xl text-lg sm:text-xl text-charcoal-soft leading-relaxed text-pretty"
                    >
                        The experiences that once shaped fear and hesitation can become the
                        foundation for clarity, confidence, and meaningful change. Therapy
                        creates the space where that transformation begins.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
                        <a
                            href={BOOKING_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hero-book-button"
                            className="editorial-button-primary group"
                        >
                            Schedule a Consultation
                            <ArrowUpRight
                                size={16}
                                strokeWidth={1.25}
                                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                            />
                        </a>
                        <a
                            href="#approach"
                            data-testid="hero-secondary-link"
                            className="gold-link text-[12px] tracking-[0.28em] uppercase font-medium text-charcoal/80"
                        >
                            The Approach
                        </a>
                    </div>

                    <div className="mt-14 flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-charcoal-soft/80" data-testid="hero-states">
                        <span className="font-serif text-gold text-base leading-none">✦</span>
                        Online across Wisconsin & Colorado
                    </div>
                </div>
            </div>
        </section>
    );
}
